<template>
  <div class="company-profile-wrapper" v-if="user.company_info.id">
    <div class="__head">
      <div class="personal_data">
        <div class="person-card">
          <img v-if="user.company_info.company_logo"
            :src="$fullUrl('images/profiles/' + user.company_info.company_logo)" />
          <img v-else src="@/assets/avatar.png" alt />
          <div class="info-text">
            <h2>{{ user.company_info.company_name | validate }}</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- company-profile display -->
    <div class="_body">
      <div class="company-profile-container" v-animate-css="'fadeIn'">
        <div class="company-profile-header">
          <div class="company-profile-brand">
            <div class="location-data">
              <span>{{ user.company_info.address | validate }}</span>
            </div>
            <div class="contact-data">
              <span v-if="user.company_info.phone">{{
                user.company_info.phone | validate
                }}</span>
              <span v-if="user.company_info.email" class="separator">|</span>
              <span v-if="user.company_info.email">{{
                user.company_info.email | validate
                }}</span>
            </div>
            <p v-if="user.company_info.description" v-html="user.company_info.description"></p>
            <div class="company-profile-option">
              <button v-if="$getLoggedUser() && parseInt($getLoggedUser().account_type) == 2"
                class="share-btn-transparent" @click="connectWithSchool()">Connect</button>
              <div class="h-spacer"></div>
              <button class="btn-send" @click="message">Message</button>
              <div class="h-spacer"></div>
              <button class="share-btn-transparent" @click="show_share = true">
                Share
              </button>
            </div>
          </div>

        </div>
        <div class="company-profile-body" v-if="false">
          <ul class="consultants-items" v-if="user.consultants.length > 0">
            <li class="consultants-starter">
              <div class="consultants-item-header">
                <label>Candidates</label>
              </div>
            </li>
            <li class="consultants-item" v-for="(item, index) in user.consultants" :key="index">
              <panel-expand :expand="false">
                <template v-slot:header>
                  <div class="consultants-item-header" @click="gotoProfile(item, 'people')">
                    <div class="consultants-item-brand">
                      <img v-if="item.profile_picture" :src="$fullUrl('images/profiles/' + item.profile_picture)
                        " alt />
                      <img v-else src="@/assets/icons/logo_avatar.svg" alt />
                    </div>
                    <div class="content">
                      <div class="title">
                        <label>{{ item.first_name | validate }}
                          {{ item.last_name | validate }}</label>
                      </div>
                      <span class="date" v-if="item.profile.available_from">{{
                        item.profile.available_from | formatDate | validate
                        }}</span>
                      <span v-else>Not Available</span>
                      <span v-if="item.profile.address">{{
                        item.profile.address | validate
                        }}</span>
                    </div>
                  </div>
                </template>
              </panel-expand>
            </li>
          </ul>
          <div class="empty-widget" v-else>
            <div class="empty-widgetheader">
              <label>Consultants</label>
            </div>
            <div class="empty-widget-body">
              <p>
                {{ user.company_info.company_name | validate }} have not yet
                added any consultants
                <!-- <br />Click below to add one -->
              </p>
              <!-- <button class="add-btn">Add a member</button> -->
            </div>
          </div>
        </div>
        <div class="company-profile-body" v-if="false">
          <ul class="project-items" v-if="user.featured_projects.length > 0">
            <li class="project-starter">
              <div class="project-item-header">
                <label>Project</label>
              </div>
            </li>
            <li class="project-item" v-for="(item, i) in user.featured_projects" :key="i">
              <panel-expand :expand="false">
                <template v-slot:header>
                  <div class="project-item-header">
                    <div class="project-item-brand">
                      <img src="@/assets/icons/projects_icon.svg" alt />
                    </div>
                    <div class="content">
                      <div class="title-row">
                        <label>{{ item.name | validate }}</label>
                        <span class="date">
                          <span v-if="item.from">{{
                            item.from | formatDate | validate
                            }}</span>
                          <span class="separator" v-if="item.from && item.to">-</span>
                          <span v-if="item.to">{{
                            item.to | formatDate | validate
                            }}</span>
                        </span>
                        <span v-if="item.address">{{
                          item.address | validate
                          }}</span>
                        <span v-else>No location added</span>
                      </div>
                      <div class="options">
                        <div class="btns"></div>
                        <span v-if="item.verified" class="verified-status">Verified</span>
                      </div>
                    </div>
                  </div>
                </template>
              </panel-expand>
            </li>
          </ul>
          <div class="empty-widget" v-else>
            <div class="empty-widgetheader">
              <label>Projects</label>
            </div>
            <div class="empty-widget-body">
              <p>
                {{ user.company_info.company_name | validate }} have not yet
                added any project
                <!-- <br />Click below to add one -->
              </p>
              <!-- <button class="add-btn">Add a project</button> -->
            </div>
          </div>
        </div>
        <div class="company-profile-body">
          <ul class="skills-items">
            <li class="skills-starter">
              <div class="skills-item-header">
                <label>Skills</label>
              </div>
            </li>
          </ul>
          <div class="skills-widget">
            <div class="skills_content__wrapper">
              <!-- Tools -->
              <div class="skill_box">
                <div class="skill_box_header">
                  <label>Tools</label>
                </div>
                <div class="skill_box_body" v-if="user.skills.tools.length > 0">
                  <div class="row__item" v-for="(item, i) in user.skills.tools.slice(0, 5)" :key="i">
                    <span>{{ item.name | validate }}</span>
                    <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                      :show-rating="false" v-model="item.priority"></star-rating>
                  </div>
                </div>
                <div class="skill_box_body" v-else>
                  <div class="empty-skills">
                    <p>
                      {{ user.company_info.company_name | validate }} haven't
                      any tool yet
                    </p>
                  </div>
                </div>
              </div>
              <!-- Competences -->
              <div class="skill_box">
                <div class="skill_box_header">
                  <label>Competences</label>
                </div>
                <div class="skill_box_body" v-if="user.skills.competences > 0">
                  <div class="row__item" v-for="(item, i) in user.skills.competences.slice(0, 5)" :key="i">
                    <span>{{ item.name | validate }}</span>
                    <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                      :show-rating="false" v-model="item.priority"></star-rating>
                  </div>
                </div>
                <div class="skill_box_body" v-else>
                  <div class="empty-skills">
                    <p>
                      {{ user.company_info.company_name | validate }} haven't
                      any competence yet
                    </p>
                  </div>
                </div>
              </div>
              <!-- Roles -->
              <div class="skill_box">
                <div class="skill_box_header">
                  <label>Roles</label>
                </div>
                <div class="skill_box_body" v-if="user.skills.roles.length > 0">
                  <div class="row__item" v-for="(item, i) in user.skills.roles.slice(0, 5)" :key="i">
                    <span>{{ item.name | validate }}</span>
                    <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                      :show-rating="false" v-model="item.priority"></star-rating>
                  </div>
                </div>
                <div class="skill_box_body" v-else>
                  <div class="empty-skills">
                    <p>
                      {{ user.company_info.company_name | validate }} haven't
                      any role yet
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="next_skills_content__wrapper">
              <!-- Domains -->
              <div class="skill_box">
                <div class="skill_box_header">
                  <label>Domains</label>
                </div>
                <div class="skill_box_body" v-if="user.skills.domains.length > 0">
                  <div class="row__item" v-for="(item, i) in user.skills.domains.slice(0, 5)" :key="i">
                    <span>{{ item.name | validate }}</span>
                    <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                      :show-rating="false" v-model="item.priority"></star-rating>
                  </div>
                </div>
                <div class="skill_box_body" v-else>
                  <div class="empty-skills">
                    <p>
                      {{ user.company_info.company_name | validate }} haven't
                      any domain yet
                    </p>
                  </div>
                </div>
              </div>
              <!-- Languages -->
              <div class="skill_box">
                <div class="skill_box_header">
                  <label>Languages</label>
                </div>
                <div class="skill_box_body" v-if="user.skills.languages.length > 0">
                  <div class="row__item" v-for="(item, i) in user.skills.languages.slice(0, 5)" :key="i">
                    <span>{{ item.lang.name | validate }}</span>
                    <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4" :star-size="14"
                      :show-rating="false" v-model="item.level"></star-rating>
                  </div>
                </div>
                <div class="skill_box_body" v-else>
                  <div class="empty-skills">
                    <p>
                      {{ user.company_info.company_name | validate }} haven't
                      any language yet
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- chat -->
    <div class="floater">
      <chat :stranger="newChat" v-if="access_token"></chat>
    </div>

    <share-helper v-if="show_share" @onClose="show_share = false" :title="user.company_info.company_name" description />
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import Chat from "@/components/Chat/Chat";

export default {
  name: "genelar-info-profile",
  components: {
    panelExpand,
    Chat,
  },
  props: {},
  data: () => {
    return {
      show_share: false,
      newChat: {},
      access_token: null,
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
        projects: [],
        featured_projects: [],
        skills: {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        },
      },
    };
  },
  mounted() {
    let vm = this;
    vm.access_token = sessionStorage.authToken;
    if (vm.$route.params.name) {
      let tmp = vm.$route.params.name.split("-");
      let id = window.atob(tmp[tmp.length - 1]);
      vm.getCompanyData(id);
    }
  },
  computed: {},
  methods: {
    connectWithSchool() {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_CONNECT_WITH_SCHOOL", { school_id: vm.user.company_info.id })
        .then((responce) => {
          vm.$notify({
            group: "status",
            title: "Important message",
            text: "Request sent successfully",
            type: "success",
            duration: 4000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Important message",
            text: "Something went wrong",
            type: "warn",
            duration: 4000,
          });
        });

    },
    gotoProfile(item, type) {
      let vm = this;
      vm.hideSearch = true;
      vm.searchHeader = "";
      if (type == "people") {
        if (item.account_type == 1) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "consultant-public-profile",
            params: { name: name },
          });
        } else if (item.account_type == 2) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "customer-public-profile",
            params: { name: name },
          });
        }
      } else if (type == "companies") {
        let item_id = window.btoa(item.id);
        let name = item.name.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "supplier-public-profile",
          params: { name: name },
        });
      } else if (type == "assignments") {
        let item_id = window.btoa(item.id);
        let name = item.title.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "assignment-public-profile",
          params: { name: name },
        });
      }
    },
    message() {
      let vm = this;
      if (vm.access_token) {
        vm.newChat = vm.user.company_info;
      } else {
        vm.$notify({
          group: "status",
          title: "It's important",
          text: "{{user.company_info.company_name | validate }} have to Login or Create account",
          type: "warn",
          duration: 4000,
        });
        vm.$router.push({ name: "login" });
      }
    },
    getCompanyData(id) {
      let vm = this;
      vm.$store
        .dispatch("GET_COMPANY_PROFILE", { id: id })
        .then((responce) => {
          vm.user = responce.data;
          let skills = vm.processSkills(vm.user.skills);
          eventBus.$set(vm.user, "skills", skills);
        })
        .catch((error) => { });
    },
    processSkills(skills_data) {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      if (skills_data && skills_data.length > 0) {
        skills_data.forEach((skill) => {
          skill.tools.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.tools.push(obj);
          });
          skill.domains.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.domains.push(obj);
          });
          skill.competences.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.competences.push(obj);
          });
          skill.roles.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.roles.push(obj);
          });
          skill.languages.forEach((item) => {
            if (item.lang) {
              let obj = {
                lang: { name: item.lang.name },
                level: parseInt(item.level),
              };
              skills.languages.push(obj);
            }
          });
        });
      }
      return skills;
    },
  },
  watch: {
    "$route.params.name"(name) {
      let vm = this;
      let tmp = vm.$route.params.name.split("-");
      let id = window.atob(tmp[tmp.length - 1]);
      vm.getCompanyData(id);
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.company-profile-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 50px;
  flex-direction: column;

  .__head {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 70px;
    width: 100%;

    .personal_data {
      width: 100%;
      height: 100%;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url($assets + "/images/backgrounds/wallpaper.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      .person-card {
        display: flex;
        align-items: center;
        flex-direction: row;

        img {
          width: 40px;
          height: 40px;
          border-radius: 100%;
          object-fit: contain;
          margin-right: 15px;
          transition: 400ms ease-in;
        }

        .info-text {
          display: flex;
          align-items: flex-start;
          flex-direction: column;

          h2 {
            font-size: 16px;
            font-weight: bolder;
            margin-bottom: 0px;
            color: #fff;
            transition: 400ms ease-in;
          }

          span {
            font-size: 13px;
            color: #fff;
            transition: 400ms ease-in;
          }
        }
      }
    }
  }

  ._body {
    width: 100%;
    overflow-y: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: calc(100vh - 70px);
    padding-bottom: 30px;

    .company-profile-container {
      padding: 1px;
      width: 800px;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
      }

      .company-profile-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        border-radius: 5px;
        background: #ffffff;
        // box-shadow: 0px 1px 3px #00000029;
        margin-bottom: 10px;

        .company-profile-brand {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .location-data,
          .contact-data {
            .separator {
              margin: 0px 20px;
            }
          }

          img {
            width: 60px;
            height: 60px;
            object-fit: contain;
            margin-bottom: 10px;
            border-radius: 50%;
          }

          span {
            font-size: 14px;
            margin-bottom: 10px;
          }

          p {
            text-align: center;
            font-size: 14px;
            line-height: 20px;

            margin: 10px 50px 10px 50px;

            @media (min-width: 300px) and (max-width: 630px) {
              margin: 10px 10px 10px 10px;
              text-align: left;
            }
          }

          .company-profile-option {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;

            .h-spacer {
              margin-right: 10px;
            }

            .btn-send {
              background: #1885ad 0% 0% no-repeat padding-box;
              border-radius: 5px;
              padding: 5px 10px;
              font-size: 14px;
              margin-top: 13px;
              color: #fff;
              cursor: pointer;
              outline: none;
              width: 180px;
              text-decoration: none;
              text-align: center;
            }

            .share-btn-transparent {
              background: #ffffff 0% 0% no-repeat padding-box;
              border: 1px solid #707070;
              border-radius: 5px;
              padding: 5px 10px;
              font-size: 14px;
              margin-top: 13px;
              color: #646262;
              cursor: pointer;
              outline: none;
              width: 180px;
              border: 1px solid #ccc;
            }
          }
        }

        .company-profile-options {
          .btn-edit-info {
            box-shadow: 0px 1px 3px #00000029;
            border: 1px solid #36adae;
            border-radius: 5px;
            color: #1885ad;
            padding: 10px 50px;
          }
        }
      }

      .company-profile-body {
        padding: 20px;
        border-radius: 5px;
        background: #ffffff;
        margin-bottom: 20px;

        ul.consultants-items {
          padding-left: 0px;
          list-style: none;

          .consultants-starter {
            margin-bottom: 6px;

            .consultants-item-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 16px 0px;

              label {
                color: #000000;

                font-size: 16px;
              }

              .btn-add-assignment {
                color: #1ba5a4;
                border: none;
                padding: 10px 10px;
                font-size: 14px;
                outline: none;
                cursor: pointer;

                font-style: italic;
                background: transparent;
              }
            }

            p {
              color: #131313;
            }
          }

          .consultants-item {
            background: #f5f5f5 0% 0% no-repeat padding-box;
            border-radius: 5px;
            margin-bottom: 10px;

            .consultants-item-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 17px 17px;

              .consultants-item-brand {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                img {
                  width: 60px;
                  height: 60px;
                  object-fit: cover;
                  margin-right: 15px;
                  border-radius: 50%;
                }
              }

              .content {
                display: flex;
                flex-direction: column;
                width: 100%;

                .title {
                  display: flex;
                  justify-content: space-between;
                  width: 100%;

                  .date {
                    color: #808080;

                    font-size: 13px;
                  }
                }

                label {
                  display: block;
                  font-size: 14px;

                  margin-bottom: 7px;
                  font-weight: 800;
                }

                span {
                  color: #808080;

                  font-size: 13px;
                  margin-bottom: 6px;
                }
              }

              .toogle-panel-btn {
                padding: 1px 40px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
              }
            }

            .consultants-item-body {
              padding: 10px;

              h4 {}

              img {
                width: 100%;
              }

              p {
                font-size: 14px;
              }

              label {
                color: #808080;
                font-size: 15px;
                display: block;
                margin-bottom: 8px;
              }

              .skills-widget {
                display: flex;
                flex-wrap: wrap;

                .skill-item {
                  background: #707070 0% 0% no-repeat padding-box;
                  border-radius: 25px;
                  color: #ffffff;
                  font-size: 13px;

                  padding: 5px 22px;
                  margin-right: 10px;
                  margin-bottom: 10px;
                }
              }

              .consultants-info {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                .col-one,
                .col-two {
                  width: 50%;

                  label {
                    color: #808080;
                    margin-bottom: 3px;
                    margin-top: 20px;
                  }

                  p {
                    color: #000;
                    margin: 0px;
                  }
                }
              }
            }
          }
        }

        .empty-widget {
          .empty-widget-body {
            height: 350px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            h1 {
              margin-bottom: 30px;
            }

            p {
              text-align: center;
              width: 270px;
            }

            .add-btn {
              width: 180px;
              height: 45px;
              background: #1890a9 0% 0% no-repeat padding-box;
              border-radius: 4px;
              color: #fff;
              outline: none;
              margin-right: 20px;
              display: center;
              justify-content: center;
            }
          }
        }
      }

      .company-profile-body {
        padding: 20px;
        border-radius: 5px;
        background: #ffffff;
        margin-bottom: 20px;

        ul.project-items {
          padding-left: 0px;
          list-style: none;

          .project-starter {
            margin-bottom: 6px;

            .project-item-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 16px 0px;

              label {
                color: #000000;

                font-size: 16px;
              }

              .btn-add-assignment {
                color: #1ba5a4;
                border: none;
                padding: 10px 10px;
                font-size: 14px;
                outline: none;
                cursor: pointer;

                font-style: italic;
                background: transparent;
              }
            }

            p {
              color: #131313;
            }
          }

          .project-item {
            background: #f5f5f5 0% 0% no-repeat padding-box;
            border-radius: 5px;
            margin-bottom: 10px;

            .project-item-header {
              display: grid;
              padding: 17px 17px;
              grid-template-columns: 90px calc(98% - 90px);
              grid-column-gap: 20px;

              @media (min-width: 300px) and (max-width: 630px) {
                grid-template-columns: 100%;
                padding: 10px 12px;
              }

              .project-item-brand {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 90px;
                height: 90px;
                background: rgb(228, 228, 228);
                border-radius: 50%;

                @media (min-width: 300px) and (max-width: 630px) {
                  width: 60px;
                  height: 60px;
                  display: none;
                }

                img {
                  width: 70px;
                  height: 70px;
                  object-fit: contain;

                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 33px;
                    height: 33px;
                  }
                }
              }

              .content {
                display: flex;
                justify-content: space-between;

                .title-row {
                  padding-right: 9px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;

                  label {
                    display: block;
                    font-size: 14px;

                    margin-bottom: 1px;
                    font-weight: 800;

                    @media (min-width: 300px) and (max-width: 630px) {
                      font-size: 12px;
                    }
                  }

                  span {
                    color: #808080;

                    font-size: 13px;
                    margin-bottom: 6px;

                    @media (min-width: 300px) and (max-width: 630px) {
                      font-size: 12px;
                    }
                  }
                }

                .options {
                  display: flex;
                  align-items: flex-end;
                  flex-direction: column;

                  .btns {
                    display: flex;
                    margin-top: -11px;
                  }

                  .verified-status {
                    color: #0590ab;
                    margin: 10px 0px;
                  }

                  .btn-verify {
                    height: 40px;
                    width: 100px;
                    outline: none;
                    color: #fff;
                    background-color: #1890a9;
                    border-radius: 5px;
                  }

                  .date {
                    color: #808080;

                    font-size: 13px;
                    display: flex;
                    justify-content: flex-end;
                    width: 188px;
                    align-items: center;

                    .separator {
                      margin: 0px 5px;
                    }

                    @media (min-width: 300px) and (max-width: 630px) {
                      font-size: 11px;
                      width: 145px;
                    }
                  }

                  .status {
                    color: #000;

                    font-size: 13px;
                  }

                  .toogle-panel-btn {
                    width: 19px;
                    padding: 0;
                    height: 22px;
                    font-size: 20px;
                    position: absolute;
                    bottom: 5px;
                    right: 7px;
                  }
                }
              }

              .toogle-panel-btn {
                padding: 1px 40px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
              }
            }

            .project-item-body {
              padding: 10px;

              h4 {}

              img {
                width: 100%;
              }

              p {
                font-size: 14px;
              }

              label {
                color: #808080;
                font-size: 15px;
                display: block;
                margin-bottom: 8px;
              }

              .skills-widget {
                display: flex;
                flex-wrap: wrap;

                .skill-item {
                  background: #707070 0% 0% no-repeat padding-box;
                  border-radius: 25px;
                  color: #ffffff;
                  font-size: 13px;

                  padding: 5px 22px;
                  margin-right: 10px;
                  margin-bottom: 10px;
                }
              }

              .project-info {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                .col-one,
                .col-two {
                  width: 50%;

                  label {
                    color: #808080;
                    margin-bottom: 3px;
                    margin-top: 20px;
                  }

                  p {
                    color: #000;
                    margin: 0px;
                  }
                }
              }
            }
          }
        }

        .empty-widget {
          .empty-widget-body {
            height: 350px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 0px 200px;

            p {
              text-align: center;
            }

            .add-btn {
              width: 180px;
              height: 45px;
              background: #1890a9 0% 0% no-repeat padding-box;
              border-radius: 4px;
              color: #fff;
              outline: none;
              margin-right: 20px;
              display: center;
              justify-content: center;
            }
          }
        }
      }

      .company-profile-body {
        padding: 20px;
        border-radius: 5px;
        background: #ffffff;
        margin-bottom: 20px;

        ul.skills-items {
          padding-left: 0px;
          list-style: none;

          .skills-starter {
            margin-bottom: 6px;

            .skills-item-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 16px 0px;

              label {
                color: #000000;

                font-size: 16px;
              }
            }
          }
        }

        .skills-widget {
          .skills_content__wrapper {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-column-gap: 10px;
            margin-bottom: 10px;

            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 1fr;
            }

            .skill_box {
              min-width: 0;
              display: flex;
              flex-direction: column;
              width: 100%;
              background: #f5f5f5;
              border-radius: 5px;
              margin-bottom: 15px;

              .skill_box_header {
                border-bottom: 2px solid #fff;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                padding: 0px 15px;

                label {
                  color: #0884af;
                  width: 100%;
                  font-size: 15px;
                  font-weight: 800;
                }
              }

              .skill_box_body {
                padding: 0px 15px;

                .empty-skills {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  height: 200px;
                  justify-content: center;

                  p {
                    text-align: center;
                    margin-bottom: 20px;
                    color: #8d8d8d;
                  }

                  button {
                    width: 133px;
                    height: 36px;
                    background: #1890a9 0% 0% no-repeat padding-box;
                    border-radius: 5px;
                    color: #fff;
                  }
                }

                .row__item {
                  margin-top: 10px;
                  display: flex;
                  margin-bottom: 10px;
                  justify-content: space-between;
                  width: 100%;

                  span {
                    color: #000000;
                    font-weight: normal;
                    margin-top: 2px;
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .next_skills_content__wrapper {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 10px;

            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 1fr;
            }

            .skill_box {
              min-width: 0;
              display: flex;
              flex-direction: column;
              width: 100%;
              background: #f5f5f5;
              border-radius: 5px;
              margin-bottom: 15px;

              .skill_box_header {
                border-bottom: 2px solid #fff;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                padding: 0px 15px;

                label {
                  color: #0884af;
                  width: 100%;
                  font-size: 15px;
                  font-weight: 800;
                }
              }

              .skill_box_body {
                padding: 0px 15px;

                .empty-skills {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  height: 200px;
                  justify-content: center;

                  p {
                    text-align: center;
                    margin-bottom: 20px;
                    color: #8d8d8d;
                  }

                  button {
                    width: 133px;
                    height: 36px;
                    background: #1890a9 0% 0% no-repeat padding-box;
                    border-radius: 5px;
                    color: #fff;
                  }
                }

                .row__item {
                  margin-top: 10px;
                  display: flex;
                  margin-bottom: 10px;
                  justify-content: space-between;
                  width: 100%;

                  span {
                    color: #000000;
                    font-weight: normal;
                    margin-top: 2px;
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}

.floater {
  position: fixed;
  bottom: 0px;
  z-index: 99999;
  right: 10px;
}
</style>